import { Breadcrumb } from "@/general/model/breadcrumb";
import { createContext } from "react";

export interface IBreadcrumbsContext {
    breadcrumbs: Breadcrumb[];
    setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
}

export const BreadcrumbsContext = createContext<IBreadcrumbsContext>(undefined);
